import React from "react"
import AsyncSelect from "react-select/lib/Async";
import { emptyString } from "react-select/lib/utils";
import { debounce } from "lodash";

class AutocompleteBadge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: props.selected ?? []
        };

        this.handleSelection = this.handleSelection.bind(this);
        this.removeBadge = this.removeBadge.bind(this);
        this.loadOptions = debounce(this.loadOptions.bind(this), 300);
    }

    loadOptions(inputValue, callback) {
        this.props.searchFunction(inputValue).then(callback);
    }

    componentDidMount() {
        if (this.props.selected) {
            this.setBadges(this.props.selected);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let propSelection = this.props.selected;
        if (propSelection && !this.arraysEqual(propSelection, prevProps.selected) && !propSelection.includes("Default")) {
            this.setBadges()
        }
    }

    setBadges = () => {
        this.removeAllBadges();

        this.props.selected.forEach((selection) => {
            this.addBadge(selection);
        })
    }

    arraysEqual(a1, a2) {
        return JSON.stringify(a1) === JSON.stringify(a2);
    };

    removeAllBadges(){
        let container = document.getElementById(this.props.title + "BadgeContainer");
        var elements = container.getElementsByClassName('badge');
        while(elements.length > 0){
            elements[0].parentNode.removeChild(elements[0]);
        }
    }

    removeBadge(e) {

        let parentEl = e.target.parentElement.parentElement;
        let removeLabel = parentEl.textContent;

        parentEl.parentElement.remove();

        this.props.onRemoval(removeLabel);
    }



    addBadge(option) {
        let container = document.getElementById(this.props.title + "BadgeContainer");
        let badge = document.createElement('span');

        let id = "remove-badge-" + option.replace(/\s+/g, '-');
        badge.className = 'tag label label-info badge';
        badge.innerHTML = ' <span class="tag location-label label-info">' +
            '            <span name="locationTag">' + option + '</span>' +
            '        <a id=' + id + '><i class="remove glyphicon glyphicon-remove-sign "></i></a>' +
            '        </span>';

        container.appendChild(badge);
        let el = document.getElementById(id);
        el.addEventListener('click', this.removeBadge, false);
    }

    handleSelection(selectedOption) {
        let options = this.props.selected;
        let selected = selectedOption.label;

        // only include text before a comma
        if (selected.indexOf(',') > -1) {
            selected = selected.substr(0, selected.indexOf(','));
        }

        if (options.indexOf(selected) === -1) {
            options.push(selected);

            this.props.onSelection(options);

            this.addBadge(selected);
        }

    }


    render() {
        let badgeContainerId = this.props.title + "BadgeContainer";

        return (
            <div>
                <div className="account">
                    <label className="label-input-account-name">
                        <div className="input">
                            <AsyncSelect
                                name="selectedOption"
                                cacheOptions
                                loadOptions = {this.loadOptions}
                                onChange = {this.handleSelection}
                                value={this.state.selectedOption}
                            />

                        </div>
                    </label>
                </div>
                <div id={badgeContainerId}></div>
            </div>
        )
    }
}

export default AutocompleteBadge;